import React from 'react';
import Link from 'next/link';
import { cn } from './cn';
import {
  navItemBaseClasses,
  navItemActiveClasses,
  navItemInactiveClasses,
  navItemIconClasses,
  navItemIconActiveClasses,
  navItemIconInactiveClasses,
} from './recipes/nav';

interface NavItemProps {
  href: string;
  icon: React.ReactElement;
  children: React.ReactNode;
  isActive: boolean;
  /** Marks the link so a feature announcement can highlight the visible copy. */
  announcementId?: string;
}

export const NavItem: React.FC<NavItemProps> = ({
  href,
  icon,
  children,
  isActive,
  announcementId,
}) => {
  const classes = cn(
    navItemBaseClasses,
    isActive ? navItemActiveClasses : navItemInactiveClasses,
    isActive && 'active'
  );

  const iconWithClasses = React.cloneElement(icon, {
    className: cn(
      navItemIconClasses,
      isActive ? navItemIconActiveClasses : navItemIconInactiveClasses
    ),
  });

  return (
    <Link
      href={href}
      className={classes}
      {...(announcementId ? { 'data-announcement': announcementId } : {})}
    >
      <span className="mr-2 flex-shrink-0">{iconWithClasses}</span>
      {children}
    </Link>
  );
};
